export enum Languages {
	Arabic = 'ar',
	Tech = 'ba',
	English = 'en',
	Japanese = 'ja',
	Korean = 'ko',
	Lithuanian = 'lt',
	Polish = 'pl',
	Russian = 'ru',
	Thai = 'th',
	Turkish = 'tr',
	Ukrainian = 'uk',
	SimplifiedChinese = 'zh-hans',
	TraditionalChinese = 'zh-hant',
	Spanish = 'es',
	Indonesian = 'bahasa',
	Italian = 'it',
	Vietnamese = 'vi',
	Greek = 'el',
	Georgian = 'ka',
	Serbian = 'sr',
	Bulgarian = 'bg'
}